import React from "react";
import {
    Box,
    IconButton,
    Switch,
    TextField,
    Typography,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import CustomDropdown from "views/common/CustomDropdown";
import MuiInput from "views/common/MuiInput";
import TechnologyFilter from "views/common/TechnologyFilter";

export const XranColumns = ({ handleDelete, handleSwitchChange, handleDateChange, handleInputChange }) => {

    const data = [
        '4G',
        '5G',
        '4G + 5G (FR2)',
        '4G + 5G (FR1)',
        '4G + 5G',
        '4G w/IOTA',
        '4G/5G',
        '4G/5G/IOTA'
    ];
    const operator = [
        'W3TIM',
        'Boldyn',
        'Vodafone',
        'Iliad',
        'Cellnex',
        'Inwit',
        'K&M Telecom',
        'K&L',
        'Siemens',
        'JMA',
        'Viaveis',
        'Vantage Tower',
        'RFIBOR',
        'CHARGE',
        'APPLE',
        'Mer Mec',
        'Comesvil',
        'NCS',
        'Salt',
        'Sunrise',
        'EE',
        'VMO2',
        'AT&T',
        'TMO',
        'CTS',
        'Boingo',
        'FWH',
        'Hughes'
    ];

    const frequencyBands = [
        'B3',
        'B7',
        'B8',
        'B40',
        'B48',
        'B25',
        'B66',
        'B1',
        'B20',
        'N257',
        'N78',
        'N48',
        'N41',
        'N71',
        'N79'
    ];


    const antennaConfigurations = [
        'SISO',
        'MIMO',
        'MIMO 2x2',
        'MIMO 4x4'
    ];

    const hardwareModels = [
        'C240',
        'R450',
        'R740',
        'R750',
        'R7515',
        'R7516',
        'R7615',
        'Advantech'
    ];


    // eslint-disable-next-line no-unused-vars
    const renderHeaderWithFilter = (headerName, required = true) => (
        <Box>
            <Typography sx={{ fontWeight: 700, color: 'white', mb: 1 }}>
                {headerName}
            </Typography>
            {/* <TextField
                placeholder="Filter..."
                size="small"
                sx={{
                    backgroundColor: 'white',
                    borderRadius: '4px',
                    '& .MuiOutlinedInput-root': {
                        height: '32px',
                    }
                }}
            /> */}
        </Box>
    );

    return [
    {
        field: "actions",
        headerName: "ACTIONS",
        width: 120,
        renderCell: (params) => (
            <IconButton
                size="small"
                sx={{ color: 'white', borderRadius: '4px', padding: '6px' }}
                onClick={() => handleDelete(params.row.id)}
            >
                <DeleteIcon fontSize="small" sx={{ color: '#e22033ff' }} />
            </IconButton>
        ),
    },
    {
        field: "systemName",
        headerName: "SYSTEM NAME",
        flex: 1,
        minWidth: 220,
        renderCell: (params) => (
            <Typography sx={{ fontWeight: 400, display: 'flex', alignItems: 'center', height: '100%' }}>
                {params.value}
            </Typography>
        ),
    },
    {
        field: "jmaActivelyInvolved",
        headerName: "JMA ACTIVELY INVOLVED?",
        flex: 1,
        minWidth: 230,
        renderCell: (params) => (
            <Switch
                checked={params.value}
                onChange={(e) =>
                    handleSwitchChange(params.row.id, 'jmaActivelyInvolved', e.target.checked)
                }
            />
        ),
    },
    {
        field: "region",
        headerName: "REGION",
        flex: 1,
        minWidth: 220,
        renderCell: (params) => (
            <CustomDropdown
                value={params.value || ''}
                onChange={(e, v) => handleInputChange(params.row.id, 'region', v || '')}
                options={[
                    'North America',
                    'Europe',
                    'US',
                    'US Federal',
                    'Asia Pacific',
                    'Latin America',
                    'Middle East',
                    'Africa',
                ].map(v => ({ label: v, value: v }))}
            />
        ),
    },
    {
        field: "topology",
        headerName: "TOPOLOGY",
        flex: 1,
        minWidth: 220,
        renderCell: (params) => (
            <CustomDropdown
                value={params.value || ''}
                onChange={(e, v) => handleInputChange(params.row.id, 'topology', v || '')}
                options={[
                    'DAS',
                    'Cell Hub',
                    'ORAN(MTI)',
                    'DAS POI ORAN',
                    'DAS POI CPRI',
                    'ORAN',
                    'Cell Hub/CPRI',
                    'POI ORAN 5G',
                ].map(v => ({ label: v, value: v }))}
            />
        ),
    },
    {
        field: "chModel",
        headerName: "CH MODEL",
        flex: 1,
        minWidth: 220,
        renderCell: (params) => (
            <MuiInput
                value={params.value || ''}
                onChange={(v) => handleInputChange(params.row.id, 'chModel', v)}
                placeholder="Enter CH Model"
            />
        ),
    },
    {
        field: "cascaded",
        headerName: "CASCADED",
        flex: 1,
        minWidth: 220,
        renderCell: (params) => (
            <Switch
                checked={params.value}
                onChange={(e) =>
                    handleSwitchChange(params.row.id, 'cascaded', e.target.checked)
                }
            />
        ),
    },
    {
        field: "technology",
        headerName: "TECHNOLOGY",
        flex: 1,
        minWidth: 220,
        renderCell: (params) => (
            <TechnologyFilter
                value={params.value || ''}
                onChange={handleInputChange}
                rowId={params.row.id}
                data={data}
            />
        ),
    },
    {
        field: "mobileOperator",
        headerName: "MOBILE OPERATOR",
        flex: 1,
        minWidth: 220,
        renderCell: (params) => (
            <TechnologyFilter
                value={params.value || ''}
                onChange={handleInputChange}
                rowId={params.row.id}
                data={operator}
            />
        ),
    },
    {
        field: "frequencyBands",
        headerName: "FREQUENCY BANDS",
        flex: 1,
        minWidth: 220,
        renderCell: (params) => (
            <TechnologyFilter
                value={params.value || ''}
                onChange={handleInputChange}
                rowId={params.row.id}
                data={frequencyBands}
            />
        ),
    },
    {
        field: "configuration",
        headerName: "CONFIGURATION",
        flex: 1,
        minWidth: 220,
        renderCell: (params) => (
            <TechnologyFilter
                value={params.value || ''}
                onChange={handleInputChange}
                rowId={params.row.id}
                data={antennaConfigurations}
            />
        ),
    },
    {
        field: "bbuServerType",
        headerName: "BBU SERVER TYPE",
        flex: 1,
        minWidth: 220,
        renderCell: (params) => (
            <TechnologyFilter
                value={params.value || ''}
                onChange={handleInputChange}
                rowId={params.row.id}
                data={hardwareModels}
            />
        ),
    },
    {
        field: "numberBbuServers",
        headerName: "NUMBER BBU SERVERS",
        flex: 1,
        minWidth: 220,
        renderCell: (params) => (
            <MuiInput
                value={params.value || ''}
                onChange={(v) =>
                    handleInputChange(params.row.id, 'numberBbuServers', v)
                }
                placeholder="Enter Number BBU Servers"
            />
        ),
    },
    {
        field: "numberOruc",
        headerName: "NUMBER ORUC",
        flex: 1,
        minWidth: 220,
        renderCell: (params) => (
            <MuiInput
                value={params.value || ''}
                onChange={(v) => handleInputChange(params.row.id, 'numberOruc', v)}
                placeholder="Enter Number ORUC"
            />
        ),
    },
    {
        field: "numberRanNodes",
        headerName: "NUMBER OF RAN NODES",
        flex: 1,
        minWidth: 220,
        renderCell: (params) => (
            <MuiInput
                value={params.value || ''}
                onChange={(v) =>
                    handleInputChange(params.row.id, 'numberRanNodes', v)
                }
                placeholder="Enter Number of RAN Nodes"
            />
        ),
    },
    {
        field: "numberSectors",
        headerName: "NUMBER SECTORS",
        flex: 1,
        minWidth: 220,
        renderCell: (params) => (
            <MuiInput
                value={params.value || ''}
                onChange={(v) =>
                    handleInputChange(params.row.id, 'numberSectors', v)
                }
                placeholder="Enter Number Sectors"
            />
        ),
    },
    {
        field: "numberRadios",
        headerName: "NUMBER RADIOS",
        flex: 1,
        minWidth: 220,
        renderCell: (params) => (
            <MuiInput
                value={params.value || ''}
                onChange={(v) =>
                    handleInputChange(params.row.id, 'numberRadios', v)
                }
                placeholder="Enter Number Radios"
            />
        ),
    },
    {
        field: "upgradeStatus",
        headerName: "UPGRADE STATUS",
        flex: 1,
        minWidth: 220,
        renderCell: (params) => (
            <CustomDropdown
                value={params.value || ''}
                onChange={(e, v) =>
                    handleInputChange(params.row.id, 'upgradeStatus', v || '')
                }
                options={['NEEDED', 'NOT NEEDED', 'COMPLETED'].map(v => ({
                    label: v,
                    value: v,
                }))}
            />
        ),
    },
    {
        field: "notes",
        headerName: "NOTES",
        flex: 1,
        minWidth: 300,
        renderCell: (params) => (
            <TextField
                value={params.value || ''}
                onChange={(e) =>
                    handleInputChange(params.row.id, 'notes', e.target.value)
                }
                multiline
                maxRows={2}
                size="small"
                fullWidth
            />
        ),
    },
];

};